
import PA from "country-flag-icons/string/3x2/PA";

const flags = { PA };

export function getFlag(language) {
  return "data:image/svg+xml," + encodeURIComponent(flags[language]);
}
